export const isPreschoolFromDob = (
  dobStr: string | Date | null | undefined,
  today: Date = new Date(),
): boolean => {
  if (!dobStr) return false;

  const dob: Date = new Date(dobStr);
  const dobYear: number = dob.getFullYear();

  const schoolYear: number =
    today.getMonth() < 8 ? today.getFullYear() - 1 : today.getFullYear();

  return schoolYear - dobYear < 5;
};
